import { Action } from '@ngrx/store';
import { User } from './auth.reducer';

export enum AuthActionTypes {
  LOGIN = '[Auth] Login',
  LOGIN_SUCCESS = '[Auth] Login Success',
  LOGIN_FAIL = '[Auth] Auth Login Fail',
  GET_USER_DETAILS = '[Auth] Get User Details',
  GET_USER_DETAILS_SUCCESS = '[Auth] Get User Details Success',
  GET_USER_DETAILS_FAIL = '[Auth] Auth Get User Details Fail',
  LOGOUT = '[Auth] Logout'
}

export class Login implements Action {
  readonly type = AuthActionTypes.LOGIN;
  constructor(public payload: { username: string; password: string }) { }
}

export class LoginSuccess implements Action {
  readonly type = AuthActionTypes.LOGIN_SUCCESS;
  constructor(public payload: User) { }
}

export class LoginFail implements Action {
  readonly type = AuthActionTypes.LOGIN_FAIL;
  constructor(public payload: Error) { }
}


export class GetUserDetails implements Action {
  readonly type = AuthActionTypes.GET_USER_DETAILS;
}

export class GetUserdetailsSuccess implements Action {
  readonly type = AuthActionTypes.GET_USER_DETAILS_SUCCESS;
  constructor(public payload: User) { }
}

export class GetUserdetailsFail implements Action {
  readonly type = AuthActionTypes.GET_USER_DETAILS_FAIL;
  constructor(public payload: Error) { }
}

export class Logout implements Action {
  readonly type = AuthActionTypes.LOGOUT;
}

export type AuthAction =
  | Login
  | LoginSuccess
  | LoginFail
  | GetUserDetails
  | GetUserdetailsSuccess
  | GetUserdetailsFail
  | Logout;

export const fromAuthActions = {
  Login,
  LoginSuccess,
  LoginFail,
  GetUserDetails,
  GetUserdetailsSuccess,
  GetUserdetailsFail,
  Logout
};
